import { jsx as _jsx } from "react/jsx-runtime";
import './style.scss';
import { forwardRef } from 'react';
const GameNavButton = forwardRef(({ status, label, disabled, onClick }, ref) => {
    return (_jsx("button", { className: `game-nav-button ${status}`, onClick: onClick, disabled: disabled, ref: ref, children: _jsx("span", { children: label }) }));
});
export default GameNavButton;
